module.exports = __webpack_public_path__ + "static/img/logo.26b21b5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.svg
// module id = 124
// module chunks = 1